/**
 * @Description 经营门店
 */

import { FC, useEffect, useState } from 'react';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import Search from './components/Search';
import TableList from './components/TableList';
import { useMethods } from '@lhb/hook';
import { famousBrandDataList, surroundCategoryPOIDataList, surroundCategorySharePOIDataList, surroundCompetitorsPagePOIDataList, surroundCompetitorsPageSharePOIDataList } from '@/common/api/siteselectionmap';
import { useBigdataFn } from '@/common/utils/bigdata';

export interface BussinessStoreProps {
  detail?: any;
  setStoreChecked?: any;
  curDetail:any;
  setCurDetail:any;
  setStoreOptions?: any;
  isShare?: boolean;
  shareParams?: any;
}

const BussinessStore: FC<BussinessStoreProps> = ({ detail, setCurDetail, setStoreOptions,
  isShare, // 是否是分享
  shareParams, // 分享时携带的参数
  ...props }) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [filters, setFilters] = useState<{ [x: string]: any }>({});// 查询条件
  const [refreshCurrent, setRefreshCurrent] = useState<boolean>(false);// 是否需要当前页刷新
  // const [loading, setLoading] = useState<boolean>(false);// 是否需要当前页刷新
  const [tableLoading, setTableLoading] = useState<boolean>(true);// 是否需要当前页刷新
  const [isNoData, setIsNodata] = useState<boolean>(false);// 是否没数据
  const [modColumn, setModColumn] = useState<any>({
    value: 'address',
    label: '地址'
  });// 表头修改

  useEffect(() => {
    if (Object.keys(filters).length && Object.keys(detail).length && 'type' in filters) {
      setTableLoading(false);
      props.setStoreChecked && props.setStoreChecked(filters);
    }
  }, [filters, detail]);

  const methods = useMethods({

    // 搜索
    onSearch: (values: { [x: string]: string }) => {
      setFilters({ ...values });
    },

    /**
     * @description 从1页重新加载
     */
    reload() {
      setRefreshCurrent(false);
      setFilters({ ...filters });
    },

    loadData: async (params: any) => { // 初始化
      // 这里加这个是为了解决 在打开抽屉时立马关闭抽屉，导致的detail被销毁，但是代码有概率会执行到此，此时下面的params的detail拿不到值，传给接口，接口会报422
      if (!detail || !Object.keys(detail).length) {
        return {
          dataSource: [],
          count: 0
        };
      }
      let api: any = '';
      let _params: any = {};
      let newModColumn = { value: 'address', label: '地址' };
      switch (filters.type + '') {
        case '1':
          _params = {
            page: params.page,
            size: params.size,
            cityId: detail.cityId,
            categoryId: params.categoryId,
            lng: detail.lng,
            lat: detail.lat,
            radius: 500,
            clusterId: detail.id,
          };
          api = famousBrandDataList;

          newModColumn = { value: 'brandName', label: '品牌名称' };
          break; // 知名品牌
        case '2':
          _params = {
            page: params.page,
            size: params.size,
            cityId: detail.cityId,
            lng: detail.lng,
            lat: detail.lat,
            radius: 500,
            clusterId: detail.id,
          };
          if (isShare) {
            _params.tenantId = shareParams?.tenantId;
            _params.userId = shareParams?.employeeId;
          }
          api = isShare && (!shareParams?.token) ? surroundCompetitorsPageSharePOIDataList : surroundCompetitorsPagePOIDataList;

          newModColumn = { value: 'brandName', label: '品牌名称' };
          break;
        default:
          _params = {
            page: params.page,
            size: params.size,
            clusterId: detail.id,
            filrstLevelCode: filters.filrstLevelCode,
            secondLevelCode: filters.secondLevelCode,
            thirdLevelCode: filters.thirdLevelCode,
          };
          if (isShare) {
            _params.tenantId = shareParams?.tenantId;
            _params.userId = shareParams?.employeeId;
          }
          api = isShare && (!shareParams?.token) ? surroundCategorySharePOIDataList : surroundCategoryPOIDataList;

          newModColumn = { value: 'address', label: '地址' };
          break;
      }
      const data = await api(_params, false);
      const { objectList } = data;

      setModColumn(newModColumn);
      // console.log(`loading = `, loading, objectList);

      return {
        dataSource: objectList.map((item, index) => {
          item.index = (params.page - 1) * params.size + index + 1;
          return item;
        }),
        count: data.totalNum,
      };

    },
  });

  return isNoData ? <></> : (
    <div className={styles['store']} >
      <V2Title divider type='H2' text={`经营门店`}/>
      <Search
        onSearch={methods.onSearch}
        detail={detail}
        setCurDetail={setCurDetail}
        setIsNodata={setIsNodata}
        setStoreOptions={setStoreOptions}
        isShare={isShare}
        shareParams={shareParams}
      />
      {!tableLoading ? <TableList
        mainHeight={521}
        filters={filters}
        onFetch={methods.loadData as any}
        refreshCurrent={refreshCurrent}
        curDetail={props?.curDetail}
        modColumn={modColumn}
        rowClassName={(record) => {
          return (record.name === props?.curDetail?.name && record.address === props?.curDetail?.address) ? 'checked pointer' : 'pointer';
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              setCurDetail(record);
              bigdataFn('23629346-0e01-4a33-885e-8149a2cfeb86', '详情-经营门店列表-点击列表', '点击了详情-经营门店列表-点击列表', { op_block: '开店区域-详情页', op_event: ``, });
            }, // 点击行
          };
        }}
        onPaginationChange={() => {
          bigdataFn('c2af9054-3309-4490-a301-a8837c867a04', '详情-经营门店列表-列表跳页', '点击了详情-经营门店列表-列表跳页', { op_block: '开店区域-详情页', op_event: ``, });
        }}
      /> : ''}
    </div>
  );
};

export default BussinessStore;
